import { COMPUTE_FIELD } from "utils/api/graphql/queries/field-registry";

/**
 * Resolves the price of one plan for a project. Returns null when the compute
 * fails so callers can keep rendering the plan without its price.
 */
export const fetchPlanPrice = async (client, projectId, planId) => {
  try {
    const { data } = await client.query({
      query: COMPUTE_FIELD,
      variables: {
        project: { id: projectId },
        key: "insurancePlanPrice",
        args: { insurancePlanId: planId },
      },
      fetchPolicy: "network-only",
    });
    return (data && data.computeField) || null;
  } catch (_) {
    return null;
  }
};

export default fetchPlanPrice;
